import { useAppSelector } from '@frontend/common';
import { allSelect, listStore, select } from '@frontend/repository';
import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import React, { forwardRef, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * TODO: this checkmark is a bit buggy
 * checkout checkbox input from common components to fix this
 */
const ID = 'table-checkbox-input';
export const Checkbox = forwardRef<
    HTMLInputElement,
    {
        indeterminate?: boolean | undefined;
        original?: { id: string } & object;
        dispatch: ThunkDispatch<any, any, Action>;
        listStoreId: string;
    }
    >(({ indeterminate, original, dispatch, listStoreId, ...rest }, ref) => {
    const checkBoxId = (original ? original.id : listStoreId) + ID;
    const store = useAppSelector(useSelector, listStore);
    const pageIndex = store[listStoreId]?.pageIndex ?? 0;
    const pageSize = store[listStoreId]?.pageSize ?? 25;
    const resolvedRef = ref;
    const selected = useMemo(() => {
        if (original) {
            if (!store[listStoreId]) return false;
            return store[listStoreId].selected!.find((o) => o.id == original!.id) != undefined;
        } else {
            if (store[listStoreId] && store[listStoreId].results) {
                const relevantObjects = store[listStoreId].pages?.[pageIndex] ?? store[listStoreId].results!;
                if (relevantObjects.length === 0) return false;
                return relevantObjects.every((obj) => store[listStoreId].selected!.find((o) => o.id == obj.id) != undefined);
            }
            return false;
        }
    }, [store[listStoreId]]);

    const handleChange = () => {
        if (original) {
            dispatch(
                select({
                    listId: listStoreId,
                    objId: original.id
                })
            );
        } else {
            dispatch(
                allSelect({
                    listId: listStoreId,
                    index: pageIndex,
                    size: pageSize
                })
            );
        }
    };

    useEffect(() => {
        if (resolvedRef && resolvedRef != null && typeof resolvedRef !== 'function' && resolvedRef.current && indeterminate != undefined)
            resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
        <div className='inline-flex items-center content-center self-center justify-center' data-testid={ID}>
            <label
                className='flex items-center cursor-pointer relative !m-0'
                htmlFor={checkBoxId}>
                <input
                    id={checkBoxId}
                    type='checkbox'
                    checked={selected}
                    ref={resolvedRef}
                    onChange={handleChange}
                    role='checkbox'
                    className='peer h-5 w-5 bg-always-white cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md hover:bg-brand-primary/50 border border-border-default checked:border-brand-primary checked:bg-brand-primary'
                />
                <span className='absolute text-always-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none'>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        className='h-3.5 w-3.5'
                        viewBox='0 0 20 20'
                        fill='currentColor'
                        stroke='currentColor'
                        strokeWidth='1'>
                        <path
                            fillRule='evenodd'
                            d='M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z'
                            clipRule='evenodd'></path>
                    </svg>
                </span>
            </label>
        </div>
    );
});

Checkbox.displayName = 'Search';
